/**
 * Created by hp on 2017/6/9.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, ActionSheet, Toast} from 'react-weui'
import axios from 'axios'
import {browserHistory} from 'react-router';

import LectureOpenLecture from './LectureOpenLecture'
import LecturePayLecture from './LecturePayLecture'
import LecturePasswordLecture from './LecturePasswordLecture'

// import LectureCollbtn from '../../images/lecture-bottom-btn.png'
// import LectureCollbtnOn from '../../images/lecture-bottom-btn-on.png'


import '../../styles/lecture/LectureBottomNav.css'
import {IconFontBox} from '../details/index.js'

// const IconFontBox = (props) => (
//     <div style={{marginRight: '-10px'}} className="icon-box lecture-bottom_btn weui-flex__item flex_1 weui-flex" onClick={props.onClickHandle}>
//         <div className="icon-box-img">
//             {props.icon}
//         </div>
//         <div className="icon-box-title">{props.title}</div>
//     </div>
// );

class LectureBottomNav extends Component {
    constructor() {
        super();
        this.onOpenGiftBar = this.onOpenGiftBar.bind(this);
        this.onOpenLectureChat = this.onOpenLectureChat.bind(this);
        this.onToggleFavourite = this.onToggleFavourite.bind(this);
        this.onEnterClassroom = this.onEnterClassroom.bind(this);
        this.onUnFavourite = this.onUnFavourite.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
        this.onCheckStudentAccess = this.onCheckStudentAccess.bind(this);
        this.onOpenLectureChat = this.onOpenLectureChat.bind(this);
        this.state = {
            autoShow: false,
            menus: [{
                label: '不再收藏',
                onClick: this.onUnFavourite
            }],
            actions: [{
                label: '取消',
                onClick: this.onRequestClose
            }]
        }
    }

    onRequestClose() {
        this.setState({autoShow: false})
    }

    onOpenLectureChat() {
        this.props.dispatch({
            type: 'LECTURE_SHOW_CHAT'
        });
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_asksome'
        })
    }

    handleSVip() {
        if (!this.props.role.is_member) {
            window.location = '/supervip'
        } else {
            this.props.dispatch({
                type: 'PAY_CHANNEL_MEMBER',
                payload: {
                    params: {
                        product: 'pay_channel_member',
                        channel_id: this.props.channel.id,
                    },
                    success: () => {
                        this.props.dispatch({
                            type: 'PAY_SUCCESS'
                        })
                        window._wk_toast && window._wk_toast.show('已添加到__br我的微课', 'success', 2000)
                        this.props.dispatch({
                            type: 'LECTURE_CHANGE_CHANNEL_SVIP_SUCCESS'
                        })
                    }
                }
            })
        }
    }

    onCheckStudentAccess() {
        const {lecture, lectureAccess, channelAccess, role, channel} = this.props;
        let isChannelAccess = channelAccess && !channelAccess.granted && !role.is_liveroom_vip;
        let isLectureAccess = !lectureAccess.granted && !role.is_liveroom_vip;

        // if ((channel && channel.is_member_goods) && role.is_member && (channelAccess && !channelAccess.granted) && !role.is_liveroom_vip && false) {
        //     return (
        //         <div className="lecture-bottom-enter-btn weui-flex__item flex_4 weui-flex" style={{fontSize: '16px'}}>
        //             <Button className="enter-btn delete-weuiafter" onClick={() => this.handleSVip()}>会员免费听</Button>
        //         </div>
        //     )
        // }

        if (lecture.lecture_type === 'password_lecture' && !lectureAccess.granted) {
            return <LecturePasswordLecture />
        }

        if (lecture.lecture_type === 'pay_lecture' && (lectureAccess.granted || (channelAccess && channelAccess.granted))) {
            return <LectureOpenLecture />
        }

        if (lecture.lecture_type === 'pay_lecture' && (isLectureAccess || isChannelAccess || (role.is_liveroom_vip && lecture.is_relay))) {
            return <LecturePayLecture />
        }

        if (lecture.lecture_type === 'open_lecture' || lectureAccess.granted || (channelAccess && channelAccess.granted) || (role.is_liveroom_vip && !lecture.is_relay)) {
            return <LectureOpenLecture />
        }

        if (lecture.lecture_type === 'pay_channel' && (isLectureAccess || isChannelAccess || (role.is_liveroom_vip && lecture.is_relay))){
            return <LecturePayLecture />
        }

        return <LectureOpenLecture />
    }

    onUnFavourite() {
        const {lecture} = this.props;
        let formData = new FormData();
        formData.append('type', 'lecture');
        formData.append('lecture_id', lecture.id);
        axios.post(`/api/favourite/delete`, formData).then((response) => {
            if (response.data.code === 0) {
                this.onRequestClose();
                this.props.dispatch({
                    type: 'LECTURE_UNSET_FAVOURITE',
                });
                this.context.page.showToast('取消收藏成功');
            }
        })
    }

    onEnterClassroom() {
        if (this.props.role.is_manager || this.props.role.is_lecturer) {
            this.props.dispatch({
                type: 'MTA_CLICK',
                payload: 'lecture_toclassroomlecturer'
            })
        } else {
            this.props.dispatch({
                type: 'MTA_CLICK',
                payload: 'lecture_toclassroomstudent'
            })
        }
        const {lecture} = this.props;
        window.location = `/classroom/${lecture.id}`;
        // location.assign(`/classroom/${lecture.id}`);
    }

    onOpenGiftBar() {
        axios.post(`/api/gift/check_buy`).then((res) => {
            if (res.data.code === 0) {
                this.props.dispatch({
                    type: 'LECTURE_SET_BUY_GIFT',
                    payload: res.data.data.has_buy,
                });
                const {hasBuyGift} = this.props;

                if (hasBuyGift) {
                    this.props.dispatch({
                        type: 'LECTURE_SHOW_GIFT_BAR'
                    });
                } else {
                    this.props.dispatch({
                        type: 'LECTURE_SHOW_GIFT_BAR_TIPS'
                    })
                }

                this.props.dispatch({
                    type: 'MTA_CLICK',
                    payload: 'lecture_giftclick'
                })
            }
        });
    }

    onOpenLectureChat() {
        this.props.dispatch({
            type: 'LECTURE_SHOW_CHAT'
        });
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_asksome'
        })
    }

    onToggleFavourite() {
        const {lecture, isFavorited} = this.props;
        let formData = new FormData();
        formData.append('type', 'lecture');
        formData.append('lecture_id', lecture.id);
        if (isFavorited) {
            this.setState({autoShow: true});
        } else {
            axios.post(`/api/favourite/add`, formData).then((response) => {
                if (response.data.code === 0) {
                    this.props.dispatch({
                        type: 'LECTURE_SET_FAVOURITE',
                    });
                    this.context.page.showToast('收藏成功');
                }
            })
        }
    }

    renderManagerBottom() {
        return (
            <div className="channel-student-bottom " style={{width: '100%', display: this.props.lecture.lecture_mode === 'default' ? 'block' : 'none'}}>
                <div className={`channel-pay-channel weui-flex`}>
                    <Button className="weui-flex__item flex_4 lecture-bottomnav_enter"
                            onClick={this.onEnterClassroom}>进入课堂</Button>
                </div>
            </div>
        );
    }

    renderStudentBottom() {
        let {isFavorited, isPresentPage,role,lecture} = this.props;

        return (
            <div className={`lecture-bottom-nav-bugsfx`}>
                {(lecture.lecture_mode === 'default' && !role.is_manager && !role.is_lecturer) && !isPresentPage &&
                    <IconFontBox
                        icon={<img src='https://static-1253442168.image.myqcloud.com/picture/6031279_84e3c998d9bd010deb1ab48c74e8eca6.jpg' alt="咨询icon"/>}
                        title='咨询'
                        onClickHandle={this.onOpenLectureChat}
                    />
                }
                {this.props.lecture.lecture_mode === 'default' && !isPresentPage &&
                <IconFontBox
                    icon={<img src={isFavorited ? 
                        'https://static-1253442168.image.myqcloud.com/picture/6031279_85feb7d394082d7c025cf67896ba095e.jpg' :
                        'https://static-1253442168.image.myqcloud.com/picture/6031279_2cd90631da64bdafe5c17e0025424806.jpg'} alt="收藏icon"/>}
                    title={isFavorited ? '已收藏' : '收藏'}
                    onClickHandle={this.onToggleFavourite}
                />
                }

                {this.onCheckStudentAccess()}

            </div>
        )
    }

    render() {
        let {autoShow, menus, actions} = this.state;
        const {role} = this.props;

        return (
            <div className="iconFontPart bottom-fixed">
                <ActionSheet actions={actions} menus={menus} show={autoShow} onRequestClose={this.onRequestClose}/>
                {(role.is_manager || role.is_lecturer) ?
                    this.renderManagerBottom()
                    :
                    this.renderStudentBottom()
                }
            </div>
        )
    }
}

LectureBottomNav.contextTypes = {
    page: React.PropTypes.object,
};

export default connect((state) => ({
    role: state.lecture.role,
    lectureAccess: state.lecture.lecture_access,
    channelAccess: state.lecture.channel_access,
    lecture: state.lecture.lecture,
    channel: state.lecture.channel,
    isFavorited: state.lecture.role.is_favorited,
    hasBuyGift: state.lecture.hasBuyGift,
}))(LectureBottomNav)



// WEBPACK FOOTER //
// ./src/components/lecture/LectureBottomNav.js